import { getMessagesForPath } from 'Components/Worksheets/Core/Helpers/messageHelpers';
import { DryingEquipment } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { pipe } from 'Lib/Hooks/Selectors';
import { joinPaths } from 'Lib/Object/Path/shared';
import deepEquals from 'Lib/Object/deepEquals';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, RadioGroup } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../Layout';
import { IWorksheetComponent, WorksheetEquipmentDropdown } from '../../../Core';
import { WorksheetBalanceFieldSet } from '../../../Core/WorksheetEquipment';

const getMoistureContentMessagesFromAllPortions = (portions: Array<any>, path: string) =>
  (portions ?? []).flatMap((p: any) => getMessagesForPath(p, joinPaths('MoistureDetermination', path)));

let AsCompactionMoistureContentDeterminationEquipmentSection: React.FC<IWorksheetComponent> = ({
  createWorksheetSelector,
}) => {
  // These fields act as shared selections for all test portions
  // We need to retrieve and show messages from those test portions
  const balanceMessages = useSelector(
    pipe(createWorksheetSelector!('TestPortions'), (portions: Array<any>) =>
      getMoistureContentMessagesFromAllPortions(portions, 'Equipment.Balance')
    ),
    deepEquals
  );
  const dryMassBalanceMessages = useSelector(
    pipe(createWorksheetSelector!('TestPortions'), (portions: Array<any>) =>
      getMoistureContentMessagesFromAllPortions(portions, 'Equipment.DryMassBalance')
    ),
    deepEquals
  );
  const dryingEquipment = useSelector(createWorksheetSelector!('Equipment.DryingEquipment')) as DryingEquipment;
  return (
    <ListFieldSection>
      <Field
        input={<RadioGroup />}
        label="Drying by"
        name="Equipment.DryingEquipment"
        options={[
          { label: 'Oven [AS 1289.2.1.1]', value: DryingEquipment.Oven },
          { label: 'Hotplate [AS 1289.2.1.6]', value: DryingEquipment.Hotplate },
        ]}
        confirm={true}
        confirmText={
          'Changing Drying By method will clear all related Moisture Content Determination values. Continue?'
        }
      />
      <WorksheetBalanceFieldSet
        label="Balance"
        name="Equipment.MoistureDeterminationBalance"
        messages={balanceMessages}
      />

      <Field
        input={<WorksheetEquipmentDropdown />}
        label="Oven"
        equipmentType="oven"
        name="Equipment.MoistureDeterminationOven"
        visible={dryingEquipment === DryingEquipment.Oven}
      />
      <Field
        input={<WorksheetEquipmentDropdown />}
        label="Hotplate"
        name="Equipment.MoistureDeterminationHotplate"
        equipmentType="hotplate"
        visible={dryingEquipment === DryingEquipment.Hotplate}
      />

      <WorksheetBalanceFieldSet
        label="Dry Mass Balance"
        name="Equipment.MoistureDeterminationDryMassBalance"
        messages={dryMassBalanceMessages}
      />
    </ListFieldSection>
  );
};

AsCompactionMoistureContentDeterminationEquipmentSection = withInjectedProps(
  AsCompactionMoistureContentDeterminationEquipmentSection
);

export { AsCompactionMoistureContentDeterminationEquipmentSection };
export default AsCompactionMoistureContentDeterminationEquipmentSection;
